// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1658":"024f3113","3540":"024f3113","4287":"024f3113","5068":"024f3113","9276":"d2c28701"}[chunkId] + ".chunk.css";
};